import React from 'react';
import { PreLoadedPlanDetails, LogoutHelper } from 'fitbeat.react-native-components';
import { HomeCarouselAuthLayout } from './Layouts/HomeCarouselAuthLayout';

export const PreLoadedPlanDetailsContainer = (props) => {
  const hasAccessToAStudioGym = props.navigation.getParam('hasAccessToAStudioGym', false);
  return (
      <HomeCarouselAuthLayout
        showHeaderSmallDevices
        hasAccessToAStudioGym={hasAccessToAStudioGym}
        {...props}>
          <PreLoadedPlanDetails {...props}/>
      </HomeCarouselAuthLayout>
  )
};